var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("組織資料中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("系統紀錄")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "col-12 mb-4 font-weight-bold"
  }, [_vm._v(" " + _vm._s("\u3010".concat(_vm.organization.name, "\u3011\u7CFB\u7D71\u7D00\u9304")) + " ")])]), _c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          align-items-start align-items-xl-center\n          mb-2\n        "
  }, [_c('b-form-select', {
    attrs: {
      "disabled": _vm.categories.length == 1,
      "options": _vm.categories
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.query.category,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "category", $$v);
      },
      expression: "query.category"
    }
  })], 1), _c('div', {
    staticClass: "\n          col-12 col-xl-6\n          d-flex\n          align-items-start align-items-xl-center\n          mb-2\n        "
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.serverLogs,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(logs)",
      fn: function fn(data) {
        return [data.item.logs.length > 60 ? _c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-full-view",
            modifiers: {
              "modal-full-view": true
            }
          }],
          staticClass: "flex-shrink-0 mr-2",
          attrs: {
            "variant": ""
          },
          on: {
            "click": function click($event) {
              _vm.logForFullView = data.item.logs;
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-arrow-expand-all"
        })]) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm._f("hiddenString")(data.item.logs, 60)))])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.total,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-full-view",
      "title": "檢視完整 Log 內容"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('JsonEditor', {
    attrs: {
      "height": "400px"
    },
    model: {
      value: _vm.logForFullView,
      callback: function callback($$v) {
        _vm.logForFullView = $$v;
      },
      expression: "logForFullView"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }